<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                size="sm"></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header">
          <b-table v-if="items.length > 0" sticky-header ref="table" stacked="lg" striped hover :items="items"
            :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left
            head-variant="light" class="sa-b-table">


            <template #cell(statoAttuale)="row">
              {{ row.item.statoAttuale }}
              <div
                style="min-width: 22px; height: 22px; display: flex; justify-content: center; align-items: center; border-radius: 50%; color: white; font-weight: 600; background-color: ">
              </div>
            </template>
            <template #cell(assistito)="row">
              <span>{{ row.item.accettazione.accettazioneAnagrafica.cognome }} {{
                row.item.accettazione.accettazioneAnagrafica.nome }}</span>
              <br />
              <small>{{ row.item.accettazione.accettazioneAnagrafica.identificativo }}</small>
            </template>

            <template #cell(actions)="row">

              <b-button size="sm" v-b-tooltip.hover title="Prestazioni" variant="outline-primary"
                @click="toggleRiga(row)">
                <font-awesome-icon :icon="isAperto(row.item.id) ? 'arrow-down' : 'arrow-left'" />
              </b-button>
              <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary  waves-effect "
                @click="onClickOpenDetailAccettazione(row.item)">
                <i class="bi bi-eye"></i>
              </b-button>
              <b-button size="sm" variant="btn btn-primary waves-effect  waves-light width-sm no-text"
                @click="onClickApriCartellaPazienze(row)" style="margin-right: 3px">
                <i class="bi bi-file-person"></i>
              </b-button>

              <b-button size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text"
                @click="onClickStampaAccettazione(row)" style="margin-right: 3px">
                <b-icon icon="printer"></b-icon>
              </b-button>

              <!-- @click="onPrintPreview(row.item)" -->
              <b-button size="sm"
                variant="btn btn-secondary outline-secondary waves-effect  waves-light width-sm no-text"
                @click="onClickAnteprimaRegistroPresenzaStampa(row.item)" style="margin-right: 3px">
                <i class="bi bi-file-ruled"></i>
              </b-button>

              <!-- <print-component :jsonData="item" :linkPrintData="linkPrintData(item)" typeButton="small" :firmaGrafometrica="true"></print-component> -->
            </template>
            <template #row-details="row">
              <b-collapse :visible="isAperto(row.item.id)" :id="'collapse-' + row.item.id">
                <b-card class="border-0 shadow-sm bg-white rounded-3">
                  <div v-for="ricetta in (listaRicetteDetails[row.item.id] || [])" :key="ricetta.id" class="mb-4">
                    <div class="p-3 border rounded-3 bg-white shadow-xs">

                      <div
                        class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom border-light">
                        <div
                          class="small fw-bold text-secondary text-uppercase tracking-wider d-flex align-items-center gap-2">
                          <span class="text-dark">NRE: {{ ricetta.codiceBar1 }}</span>
                          <span class="text-primary p-1"> • </span>
                          <span :class="ricetta.codiceBar2 ? 'text-primary fw-normal' : 'text-danger fw-semibold'">
                            {{ ricetta.codiceBar2 || "Privata" }}
                          </span>
                        </div>
                      </div>

                      <div v-for="(prestazione, idx) in ricetta.prestazioni" :key="prestazione.id"
                        :class="{ 'mt-3 pt-3 border-top border-light': idx > 0 }"
                        v-b-toggle="'collapse-prestazione-' + idx">

                        <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
                          <span class="fw-semibold  text-dark " style="line-height: 1.4;">
                            {{ idx + 1 }}) {{ prestazione.codicePrestazione }} — {{ prestazione.descrizionePrestazione
                            }}
                          </span>



                          <div class="d-flex align-items-center gap-1">
                            <span class="badge rounded-circle d-flex align-items-center justify-content-center" :style="{
                              minWidth: '18px',
                              height: '18px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '50%',
                              background: getColorBackGround(prestazione),
                              color: '#000000',
                              fontWeight: '700',
                              fontSize: '11px',
                              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                            }">
                              {{ prestazione.appuntamenti ? prestazione.appuntamenti.length : 0 }}
                            </span>
                            <span class="fw-bold text-dark" style="font-size: 12px; padding:3px;">/</span>
                            <span class="badge rounded-circle d-flex align-items-center justify-content-center"
                              style="min-width: 18px; height: 18px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background: #00a3ff; color: #000000; font-weight: 700; font-size: '11px'; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15)">
                              {{ prestazione.quantitaErogabile }}
                            </span>
                            <div class="ml-4">
                              <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange">▼ </span>
                            </div>
                          </div>

                        </div>
                        <b-collapse :id="'collapse-prestazione-' + idx">
                          <div v-if="prestazione.appuntamenti && prestazione.appuntamenti.length > 0"
                            class="d-flex flex-wrap p-1 align-items-center gap-2 mt-2"
                            style="justify-content: space-between;">
                            <span class="text-primary fw-bold text-uppercase me-1 w-100"
                              style="font-size: 10px; letter-spacing: 0.5px;  ">
                              Appuntamenti:
                            </span>
                            <div v-for="appuntamento of prestazione.appuntamenti" :key="appuntamento.id"
                              class="d-inline-flex flex-column justify-content-center px-3 py-2 rounded bg-white border border-info-subtle shadow-xs"
                              style="font-size: 11px; line-height: 1.3;  min-width: 80px; gap: 5px; transition: all 0.2s ease-in-out; cursor: default; border-left: 3px solid #00a3ff !important;"
                              onmouseover="this.style.backgroundColor='#f4faff'; this.style.borderColor='#00a3ff';"
                              onmouseout="this.style.backgroundColor='#ffffff'; this.style.borderColor='#cff4fc';"
                              :title="appuntamento.titolo">
                              <div class="text-dark fw-bold text-nowrap mb-1">
                                <span style="color: #0077b6;">{{ formatDate(appuntamento.dataOraInizio) }}</span>
                                <span class="mx-1 text-muted">|</span>
                                <span>{{ getOra(appuntamento.dataOraInizio) }} - {{ getOra(appuntamento.dataOraFine)
                                }}</span>
                              </div>
                              <span class="text-dark text-truncate fw-medium text-center"
                                style="max-width: 160px; font-size: 11px;">
                                {{ appuntamento.titolo }}
                              </span>
                              <span class="text-dark text-truncate fw-medium text-center"
                                style="max-width: 160px; font-size: 11px;">
                                {{ appuntamento.numeroOrdine }}
                              </span>
                            </div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-collapse>
            </template>

          </b-table>
          <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti accettazioni" nome="no-data"
            subtitle="" icon="fas fa-users" />
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
              size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal></b-modal>

      <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";

import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast.js";
export default {
  //PrintComponent
  mixins: [UtilityMixin],
  components: { PdfPrintViewEmbedded, NoDataComponent },
  data() {
    return {
      pathResource: "/accettazionessn",
      pathResourceRicette: "/accettazionericette",
      items: [],
      righeAperte: [],
      rows: 0,
      filtro: {
        codiceFiscaleAssistito: null,
        idPresidio: null,
      },
      page: 1,
      perPage: 10000,
      signedPdfViewer: null,
      listKey: 0,
      previewSelected: null,
      currentPage: 1,
      rowSelectedAccettazione: {},
      listaRicetteDetails: {},
      fields: [
        {
          label: "C.F Assistito",
          key: "assistito",
        },
        {
          label: "Stato",
          key: "statoAttuale",
        },
        {
          label: "Data Ora Accettazione",
          key: "createDate",
          formatter: (param) => {
            return UtilityMixin.methods.formatDateTime(param);
          },
        },
        {
          label: "Ricette",
          key: "numeroRicette",
          class: "text-center"
        },
        {
          label: "",
          class: "sa-table-column-action-double",
          key: "actions",
        },
      ],
    };
  },
  mounted() {
    let me = this;



    me.init();
  },
  methods: {
    init() {
      let me = this;

      me.loadData();
    },
    getOra(date) {
      return moment(date).format("HH:mm");
    },
    getFormatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },
    isAperto(id) {
      return this.righeAperte.includes(id);
    },
    toggleRiga(row) {
      const id = row.item.id;
      const index = this.righeAperte.indexOf(id);
      const dettaglioEsiste = this.listaRicetteDetails[row.item.id];
      if (index > -1 && dettaglioEsiste) {
        this.righeAperte.splice(index, 1);
      } else {
        let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
        axios
          .get(link, { params: { idAccettazione: row.item.id } })
          .then((response) => {
            this.listaRicetteDetails[row.item.id] = response.data.data.list;
            this.righeAperte.push(id);
          })
          .catch((error) => {
            console.log(error);
          });

      }
      row.toggleDetails();
    },
    gestisciApertura(item, index) {
      if (item) {
        this.$set(item, 'isOpen', true);
        console.log(`Gruppo ${index} aperto`);
      }
      console.log(item);
    },
    gestisciChiusura(item, index) {
      console.log(item);

      if (item) {
        this.$set(item, 'isOpen', false);
        console.log(`Gruppo ${index} chiuso`);
      }
    },
    loadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPageAccettazioneSsn");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      if (me.filtro != null) {
        me.filtro.page = me.currentPage;
        me.filtro.forPage = me.perPage;
        if (me.filtro.idPresidio == null) {
          me.$emit("afterLoadData");
          toast.warning("Id Presidio Obbligatorio")
          return;
        }
      }

      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.listKey++;
      me.$emit("afterLoadData");
    },
    loadDataAccettazioneSsnError(response) {
      let me = this;
      me.$emit("afterLoadData", response);
      console.log(response);

      me.$bvToast.toast(response.response.data.messaggio, {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
    getColorBackGround(prestazione) {
      let color = "#b6b5b5";
      color = prestazione.appuntamenti.length == prestazione.quantitaErogabile ? "#00a3ff" : "#ffc107";
      return color;
    },
    linkPrintData(item) {
      let returnValue = "/printer/" + item.id;
      return returnValue;
    },
    onClickOpenDetailAccettazione(accettazione) {
      this.$router.push("accettazionessn/" + accettazione.id);
    },
    // onClickDettaglio(row) {
    //   if (this.listaRicetteDetails[row.item.id]) {
    //     row.toggleDetails();
    //   } else {
    //     this.loadRicetteByAccettazione(row);
    //   }
    // },
    onClickStampaAccettazione(row) {
      let link = process.env.VUE_APP_PATH_API + "/accettazionessn/" + row.item.id;
      axios
        .get(link, { params: { idAccettazione: row.item.id } })
        .then((response) => {
          console.log(response);
          let acce = response.data.data;
          let print = {
            reportName: "StampaPrestazioneAccettazione",
            data: {
              ...acce
            },
          };
          this.onPrintPreview(print);
        })
        .catch((error) => {
          console.log(error);
        });

    },
    onClickApriCartellaPazienze(row) {
      if (row.item.idPaziente) {
        this.$router.push("/rsapaziente/view/" + row.item.id)

      }

    },
    loadRicetteByAccettazione(row) {
      let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
      axios
        .get(link, { params: { idAccettazione: row.item.id } })
        .then((response) => {
          this.listaRicetteDetails[row.item.id] = response.data.data.list;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onClickAnteprimaRegistroPresenzaStampa(item) {

      let link = process.env.VUE_APP_PATH_API + "/accettazionessn/print";
      axios
        .get(link, { params: { idAccettazione: item.accettazione.id } })
        .then((response) => {

          let print = {
            reportName: "RegistroPresenze",
            data: {
              ...response.data.data
            },

          };
          this.onPrintPreview(print);
        })
        .catch((error) => {
          console.log(error);
        });


      // let print = {
      //   reportName: "RegistroPresenze",
      //   data: {
      //     identificativo: identificativo,
      //     prestazioni: prestazioni,
      //   },
      // };
      // me.onPrintPreview(print);
    },
    onClickAnnulla() {
      let me = this;
      me.$refs.mdlPreviewStampa.hide();
    },
    onPrintPreview(item) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/print/createreport";
      me.showModalLoading = true;
      axios
        .post(link, item)
        .then((response) => {
          me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;

          me.$refs.pdfPrintViewEmbedded.show();
        })
        .catch((error) => {
          // me.$refs.mdlGenerazioneReportInCorso.hide();
          me.showModalLoading = false;
          let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito, Codice: " + error.response.status;
          this.$bvModal
            .msgBoxOk(messaggio, {
              title: this.$i18n.t("ERROR!"),
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "sa-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((value) => {
              this.boxTwo = value;
            })
            .catch((err) => {
              err;
            });
        });
    },
  },
  watch: {
    // currentPage() {
    //   let me = this;
    //   me.loadData();
    // },
  },
};
</script>

<style scoped>
.ft-wrapper-ricetta {
  margin-bottom: 16px;
}

.ft-ricetta-titolo {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
}

/* Prestazioni orizzontali */
.ft-wrapper-prestazioni {
  display: flex;

  gap: 16px;
}

.ft-prestazione-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f9f9f9;
}

.ft-prestazione-codice {
  font-weight: 600;
  margin-bottom: 6px;
}

.ft-prestazione-badge-container {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}

.ft-badge {
  min-width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-weight: 600;
}

.ft-badge-complete {
  background-color: #00a3ff;
}

.ft-badge-incomplete {
  background-color: #ffc107;
}

.ft-badge-total {
  background-color: #00a3ff;
}

.sa-badge-internal {
  border-radius: 5px;
  border-left: 4px solid var(--bg-sidebar-item);
  border-top: 1px solid var(--bg-main-nav-bar);
  border-bottom: 1px solid var(--bg-main-nav-bar);
  border-right: 1px solid var(--bg-main-nav-bar);
  padding: 7px !important;
  margin-bottom: 5px;
  max-width: max-content;
}

.sa-ft-arrow-icon {
  display: inline-block;
  /* FONDAMENTALE per far funzionare il transform */
  transition: transform 0.2s ease-in-out;
  font-size: 0.75rem;
  color: #6c757d;
  cursor: pointer;
}

/* Quando è open, ruota di 180 gradi */
[aria-expanded="true"] .sa-ft-arrow-icon {
  transform: rotate(180deg);
}

.sa-ft-circle-wrapper-orange {
  /* Dimensioni e Forma */
  width: 30px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;

  /* Centratura del numero */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estetica */
  background-color: #ff660021;
  color: rgba(233, 71, 22, 0.801);
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;

  /* Opzionale: bordino o ombra */
  border: 2px solid #b34800;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-badge {
  width: 100%;
  max-width: none !important;
}
</style>
